<template>
  <div>

    <!-- Hero Start -->
    <section class="position-relative bg-center bg-cover" :style="{ backgroundImage: `url(${backgroundUrl})` }">
      <div class="absolute inset-0 bg-black opacity-90"></div>
      <div class="container-fluid relative">
        <div class="grid grid-cols-1">
          <div class="lg:col-span-4">
            <div class="flex flex-col min-h-screen md:px-12 py-8 px-3">
              <!-- Start Logo -->
              <div class="text-center mx-auto">
                <router-link to="/">
                  <img :src="logo" class="h-28" alt="Sultan Flowers Extracts Place" decoding="async" />
                </router-link>
              </div>
              <!-- End Logo -->

              <!-- Start Content -->
              <div class="text-center my-auto">
                <div
                    class="w-full max-w-sm m-auto px-6 py-8 bg-white dark:bg-slate-900 rounded-md shadow-lg shadow-slate-500 dark:shadow-slate-800">
                  <div class="grid grid-cols-1">
                    <h5 class="mb-8 text-xl dark:text-white font-semibold">Login</h5>
                    <form @submit.prevent="login" class="ltr:text-left rtl:text-right">
                      <div class="grid grid-cols-1">
                        <div class="mb-4">
                          <label class="dark:text-white" for="LoginEmail">Email Address:</label>
                          <input v-model="user.email" id="LoginEmail" type="email" class="form-input mt-3"
                                 placeholder="name@example.com">
                          <p v-if="errors.email" class="text-red-500 text-xs font-medium p-2">
                            {{ errors.email[0] }}</p>
                        </div>

                        <div class="mb-4">
                          <label class="dark:text-white" for="LoginPassword">Password:</label>
                          <input v-model="user.password" id="LoginPassword" type="password" class="form-input mt-3"
                                 placeholder="Password:">
                          <p v-if="errors.password" class="text-red-500 text-xs font-medium p-2">
                            {{ errors.password[0] }}</p>
                        </div>

                        <div v-if="errorMsg" class="mb-4 border-red-600 border rounded">
                          <p class="text-red-500 text-xs font-medium p-2 text-center">{{ errorMsg }}</p>
                        </div>

                        <div class="mb-4">
                          <button
                              type="submit"
                              class="btn bg-orange-600 hover:bg-orange-700 border-orange-600 hover:border-orange-700 text-white rounded-md w-full flex items-center justify-center"
                              :disabled="loading"
                          >
                            <span v-if="loading"
                                  class="animate-spin border-2 border-white border-t-transparent rounded-full w-5 h-5 mr-2"></span>
                            <span>{{ loading ? 'Logging in...' : 'Login' }}</span>
                          </button>
                        </div>
                        <div class="text-center">
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
              <!-- End Content -->
              <!-- End Footer -->
            </div>
          </div><!--end col-->
        </div><!--end row-->
      </div><!--end container-->
    </section><!--end section-->
    <!-- Hero End -->
    <SwitcherSection/>
  </div>
</template>

<script setup>
import {onBeforeMount, ref} from 'vue'
import SwitcherSection from '../../components/SwitcherSection.vue'
import logo from '@/assets/logo.png'
import backgroundUrl from '../../assets/images/bg/auth.jpg'
import store from "../../store";
import router from '../../router';

let loading = ref(false)
let errorMsg = ref("")
const errors = ref({})
const user = {
  email: '',
  password: '',
}

function initErrors() {
  errors.value = {}
  errorMsg.value = ""
}

function login() {
  loading.value = true
  initErrors()
  store.dispatch('login', user)
      .then(() => {
        router.push({name: 'app.reviews'})
      })
      .catch(({response}) => {
        if (response.status === 422) {
          errors.value = response.data.errors
        } else {
          errorMsg.value = response.data.message;
        }
      }).finally(() => {
    loading.value = false
  })
}

onBeforeMount(() => {
  document.documentElement.classList.add('light')
  document.documentElement.setAttribute('dir', 'ltr')

  const bodyElement = document.body
  bodyElement.classList.add(
      'font-rubik',
      'text-base',
      'text-slate-900',
      'dark:text-white',
      'dark:bg-slate-900'
  )
})

</script>